module.exports = __webpack_public_path__ + "img/avatar1.766b9ad4.png";